import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDisabledPlayButton = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 12,
			fill: "#DEE3F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7133 11.208L9.06412 6.10732C8.51964 5.78745 7.85938 6.22082 7.85938 6.90183V17.0997C7.85938 17.7807 8.51964 18.2141 9.06412 17.8908L17.7133 12.7936C18.289 12.4531 18.289 11.5485 17.7133 11.208Z",
			fill: "#7683A8"
		})
	]
});
const ForwardRef = forwardRef(SvgDisabledPlayButton);
export default ForwardRef;
